import {Material} from '@wonderlandengine/api';

export enum Team {
    RED = 0,
    BLUE = 1,
}

export const TeamName = ['Red', 'Blue'];

export const TeamMaterials: (Material | null)[] = [null, null];
